var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53516 9.99996C8.53516 9.19454 9.18807 8.54163 9.99349 8.54163H10.001C10.8064 8.54163 11.4593 9.19454 11.4593 9.99996C11.4593 10.8054 10.8064 11.4583 10.001 11.4583H9.99349C9.18807 11.4583 8.53516 10.8054 8.53516 9.99996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52856 15C8.52856 14.1945 9.18148 13.5416 9.9869 13.5416H9.9944C10.7998 13.5416 11.4527 14.1945 11.4527 15C11.4527 15.8054 10.7998 16.4583 9.9944 16.4583H9.9869C9.18148 16.4583 8.52856 15.8054 8.52856 15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54175 4.99996C8.54175 4.19454 9.19466 3.54163 10.0001 3.54163H10.0076C10.813 3.54163 11.4659 4.19454 11.4659 4.99996C11.4659 5.80538 10.813 6.45829 10.0076 6.45829H10.0001C9.19466 6.45829 8.54175 5.80538 8.54175 4.99996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconWhite);
export default __webpack_public_path__ + "static/media/menu-icon-white.f5eb6261018521d8bd9bdbf36d5fcd56.svg";
export { ForwardRef as ReactComponent };